// extracted by mini-css-extract-plugin
export default {"recommendations":"recommendations_recommendations__PPXCx","recommended-card":"recommendations_recommended-card__qCSge","children":"recommendations_children__rqNqK"};